import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import y from 'y4/Utils';

const LoadingButton = ({ loadingText, onClick, ...rest }) => {
  const [isLoading, setLoading] = useState(false);
  useEffect(() => {
    if (isLoading) {
      var result = onClick();
      Promise.resolve(result).then(() => {
        setLoading(false);
      });
    }
  }, [isLoading]);

  const handleClick = () => setLoading(true);
  return (
    <Button
      {...rest}
      disabled={isLoading}
      onClick={!isLoading ? handleClick : null}
    >
      {isLoading ? y.et(loadingText, rest.children) : rest.children}
    </Button>
  );
};

LoadingButton.propTypes = {
  loadingText: PropTypes.string,
  onClick: PropTypes.func
};

export default LoadingButton;
